module.exports = __webpack_public_path__ + "fa-regular-400.b91d376b8d7646d671cd.woff2";


//////////////////
// WEBPACK FOOTER
// F:/node/angular/complejidadesFrontend/~/@fortawesome/fontawesome-free/webfonts/fa-regular-400.woff2
// module id = ../../../../@fortawesome/fontawesome-free/webfonts/fa-regular-400.woff2
// module chunks = 2